import React from 'react';
import {TextLoading, TextRequestFailed} from './misc';
import {useLatestBlocks} from '../../queries';
import BlockList from '../../components/BlockList';

const LatestBlocksContent = ({allowExpand = false}) => {
    const latestBlocksQuery = useLatestBlocks();
    if (latestBlocksQuery.isLoading) {
        return TextLoading;
    }
    if (latestBlocksQuery.isError) {
        return TextRequestFailed;
    }

    return <BlockList data={latestBlocksQuery.data.payload} allowExpand={allowExpand}/>;
};

export default LatestBlocksContent;
